module.exports = __webpack_public_path__ + "static/media/3775.a3f838a3.jpg";